import React from 'react';
import { Box, Icons, Text, useTheme } from '@ublend-npm/aulaui-core';
import pushRoute from '@app/utils/routing';
import { DARK } from '@core/constants/theme';

interface NavigationBackHeaderProps {
  wrapperStyle?: any;
  route?: string | null;
  onClick?: () => void;
}
// Common header with back button for navigation
const NavigationBackHeader: React.FC<NavigationBackHeaderProps> = ({
  wrapperStyle = {},
  route = null,
  onClick,
}) => {
  // Theme palette
  const { palette } = useTheme();
  const isDarkMode = palette?.mode === DARK;
  // Text color for each theme
  const textColor = isDarkMode ? palette.primary.light : palette.primary.dark;

  return (
    <Box sx={wrapperStyle}>
      <Box
        tabIndex={0}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          gap: '8px',
          alignItems: 'center',
          marginLeft: '-4px',
          padding: '8px 11px',
          maxWidth: 'fit-content',
          '&:hover': {
            backgroundColor: palette.action.hover,
            borderRadius: '4px',
          },
        }}
        onClick={() => {
          if (onClick) {
            onClick();
          } else if (route) {
            const queryIndex = route.indexOf('?');
            if (queryIndex === -1) {
              pushRoute({ pathname: route, state: { source: 'back_button' } });
              return;
            }

            const pathname = route.slice(0, queryIndex);
            const query = Object.fromEntries(
              new URLSearchParams(route.slice(queryIndex + 1)).entries()
            );
            pushRoute({ pathname, query, state: { source: 'back_button' } });
          }
        }}
        aria-label="Back button, returns to previous page. To click this button, press Control-Option-Space"
      >
        <Icons.WestOutlined sx={{ color: textColor }} />
        <Text
          sx={{
            fontSize: '1rem',
            color: textColor,
            fontWeight: 500,
          }}
        >
          Back
        </Text>
      </Box>
    </Box>
  );
};

export default NavigationBackHeader;
